import type * as ReactRouter from "react-router";
import { MonitoringPage } from "~/app/components/landing/monitoring-page";
import { getTranslationFn } from "~/app/i18n";

const t = getTranslationFn("pl");

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("Monitoring.metaTitle") },
  { name: "description", content: t("Monitoring.metaDescription") },
];

export default function MonitoringPL() {
  return <MonitoringPage locale="pl" />;
}
